const isDeloitte = organizationName => (
  organizationName?.toLowerCase() === "deloitte"
);

export default isDeloitte;
